import Panel from '../components/panel.tsx'
import {Button} from '../components/button.tsx'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";


export default function ModalInfoHeizkessel() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <ul className="list">   
                <li className="list__item">Öl-Konstanttemperaturkessel (ca. 1970er bis frühe 1990er Jahre): Eine ältere Öl-Heizung, die unabhängig vom Wärmebedarf dauerhaft mit hoher Kesseltemperatur läuft und dadurch vergleichsweise viel Energie verbraucht.</li>
                <li className="list__item">Öl-Niedertemperaturkessel (ca. frühe 1980er bis Anfang 2000er Jahre): Eine Öl-Heizung, die ihre Vorlauftemperatur automatisch an den Wärmebedarf anpasst und dadurch sparsamer arbeitet als Konstanttemperaturkessel.</li>
                <li className="list__item">Öl-Brennwertkessel (ab Mitte/Ende 1990er Jahre bis heute): Eine moderne Öl-Heizung, die zusätzlich die Wärme aus den Abgasen nutzt, indem sie den darin enthaltenen Wasserdampf kondensiert und so einen besonders hohen Wirkungsgrad erreicht.</li>
                <li className="list__item">Gas-Konstanttemperaturkessel (ca. 1970er bis frühe 1990er Jahre): Eine ältere Gas-Heizung, die dauerhaft mit hoher Kesseltemperatur betrieben wird und dadurch viel Energie verbraucht, unabhängig vom Wärmebedarf.</li>
                <li className="list__item">Gas-Niedertemperaturkessel (ca. frühe 1980er bis Anfang 2000er Jahre): Eine Gas-Heizung, die ihre Vorlauftemperatur automatisch an den tatsächlichen Wärmebedarf anpasst und damit effizienter arbeitet als Konstanttemperaturkessel.</li>
                <li className="list__item">Gas-Brennwertkessel (ab Mitte/Ende 1990er Jahre bis heute): Eine moderne Gas-Heizung, die zusätzlich die Wärme aus den Abgasen durch Kondensation des Wasserdampfs nutzt und so den höchsten Wirkungsgrad erreicht.</li>
            </ul>

            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

